import React, { useEffect, useRef } from "react";

const TimedRoutine = ({ routine, isLrVideo }) => {
  const { videoLink, lrVideoLink } = routine;
  const videoRef = useRef(null);

  const src = isLrVideo ? lrVideoLink : videoLink;

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;

    const tryPlay = async () => {
      try {
        await video.play();
      } catch (err) {
        console.warn("Playback failed:", err);
      }
    };

    tryPlay();

    let lastTime = video.currentTime;

    const interval = setInterval(() => {
      if (!video || video.paused) return;

      const delta = Math.abs(video.currentTime - lastTime);

      if (delta < 0.01) {
        console.warn("Video appears frozen. Attempting recovery...");

        video.play().catch(() => {
          video.load();
          tryPlay();
        });
      }

      lastTime = video.currentTime;
    }, 5000);

    const handleVisibility = () => {
      if (!document.hidden) {
        tryPlay();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [src]);

  return (
    <div className="video-container">
      <video
        ref={videoRef}
        src={src}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />
    </div>
  );
};

export default TimedRoutine;
